import { useState, useEffect, useRef } from "react";
import Topheader from "../../component/Topheader";
import { useNavigate } from "react-router-dom";
import API_URL from "../../config";
import axios from "axios";

const AddCategory = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null); // For resetting file input
  const [formData, setFormData] = useState({
    logo: "",
    category_name: "",
    category_description: "",
  });
  const [errors, setErrors] = useState({});
  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    let newError = {};

    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        newError.logo = "File size too large. Maximum size is 5MB";
        setErrors(newError);
        return;
      }

      const allowedTypes = [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "image/svg+xml",
      ];
      if (!allowedTypes.includes(file.type)) {
        newError.logo =
          "Invalid file type. Only PNG, JPG, JPEG, and SVG are allowed";
        setErrors(newError);
        return;
      }

      setFormData((prev) => ({
        ...prev,
        logo: file,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newError = {};

    if (!formData.logo) newError.logo = "Logo is required";
    if (!formData.category_name) newError.cat_name = "Category Name is required";
    if (!formData.category_description) newError.cat_desc = "Category Description is required";

    if (Object.keys(newError).length > 0) {
      setErrors(newError);
      return;
    }

    setErrors({});
    setSubmit(true);

    try {
      const submitFormData = new FormData();
      submitFormData.append("category_name", formData.category_name);
      submitFormData.append("category_description", formData.category_description);
      submitFormData.append("logo", formData.logo);

      const response = await axios.post(
        `${API_URL}/api/categories/add-category`,
        submitFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Category added successfully!");

      // Reset form and file input
      setFormData({
        logo: "",
        category_name: "",
        category_description: "",
      });

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Error", error);
      alert(
        error?.response?.data?.message ||
          "An error occurred while submitting the form."
      );
    }
  };

  return (
    <div className="">
      {/* <Topheader /> */}
      <div className="">
        <div className="container-fluid">
          <div className="card bg-info-subtle shadow-none position-relative overflow-hidden mb-4">
            <div className="card-body px-4 py-3">
              <div className="row align-items-center">
                <div className="col-9">
                  <h4 className="fw-semibold mb-8">Add Category</h4>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a className="text-muted text-decoration-none" href="../dark/index.html">
                          Home
                        </a>
                      </li>
                      <li className="breadcrumb-item" aria-current="page">
                        Template
                      </li>
                      <li className="breadcrumb-item" aria-current="page">
                        Add Category
                      </li>
                    </ol>
                  </nav>
                </div>
                <div className="col-3">
                  <div className="text-center mb-n5">
                    <img
                      src="../../assets/assets/images/backgrounds/welcome-bg.svg"
                      alt="breadcrumb-img"
                      className="img-fluid mb-n4"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-8 justify-content-center mx-auto">
              <div className="card shadow-sm">
                <div className="container py-5">
                  <h1 className="mb-4">Add Category</h1>
                  <form className="mb-4" onSubmit={handleSubmit}>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label htmlFor="logo" className="form-label">
                          Category Logo
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          id="logo"
                          name="logo"
                          onChange={handleFileChange}
                          ref={fileInputRef}
                        />
                        {errors.logo && (
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {errors.logo}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="category_name" className="form-label">
                          Category Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Category Name"
                          id="category_name"
                          name="category_name"
                          onChange={handleChange}
                          value={formData.category_name}
                        />
                        {errors.cat_name && (
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {errors.cat_name}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label htmlFor="category_description" className="form-label">
                          Category Description
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Category Description"
                          id="category_description"
                          name="category_description"
                          onChange={handleChange}
                          value={formData.category_description}
                        />
                        {errors.cat_desc && (
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {errors.cat_desc}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <button type="submit" className="btn btn-primary w-100">
                        Add Category
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
